export default {
  wrongAddressFormat: 'Format alamat salah',
  disconnectWallet: 'Putuskan koneksi dompet',
  memo: 'Memo',
  stage: 'Tahap',
  tokenomics: 'Tokenomics',
  tokensPurchased: 'Token yang dibeli',
  youShouldAgree: 'Anda harus menyetujui syarat & ketentuan',
  requiredField: 'Kolom wajib diisi',
  minValueIs: 'Nilai minimum adalah',
  maxValueIs: 'Nilai maksimum adalah',
  cannotCopyToClipboard: 'Tidak dapat menyalin ke papan klip',
  copiedToClipboard: 'Berhasil disalin ke papan klip',
  failed: 'Tindakan gagal',
  success: 'Tindakan berhasil',
  aboutUs: 'Tentang Kami',
  bonuses: 'Bonus',
  whitepaper: 'Whitepaper',
  team: 'Tim',
  community: 'Komunitas',
  checkAddress: 'Periksa alamat',
  bonusToBase: 'BONUS UNTUK HARGA DASAR',
  raised: 'terkumpul',
  listingPrice: 'HARGA LISTING',
  scrollDownTo: 'Gulir ke bawah untuk mempelajari lebih lanjut',
  keyFeaturesOf: 'Fitur Utama Dompet DOLLUM',
  essentialDollumFeatures:
    'Fitur esensial Dompet DOLLUM yang dirancang untuk keamanan dan kenyamanan Anda.',
  commissionOptimizer: 'Pengoptimal Komisi',
  reduceTransactionCosts:
    'Kurangi biaya transaksi secara otomatis memilih biaya terendah yang tersedia.',
  emergencyStopMode: 'Mode Berhenti Darurat',
  instantlyProtectAssets:
    'Lindungi aset secara instan dengan mengubahnya menjadi USDT dalam keadaan darurat.',
  antiHijackFeature: 'Fitur Anti-Pembajakan',
  lockYourWallet:
    'Kunci dompet Anda ketika di bawah ancaman dengan mengaktifkan sinyal darurat tersembunyi.',
  cryptoInvestmentPortfolio: 'Portofolio Investasi Kripto',
  manageYourCrypto:
    'Kelola investasi kripto Anda dengan portofolio siap pakai dalam satu klik.',
  backupAddress: 'Alamat Cadangan',
  redirectAssetsTo:
    'Arahkan aset ke alamat cadangan setelah periode tidak aktif yang lama.',
  bonusStages: 'TAHAPAN BONUS',
  over320Million:
    'Lebih dari 320 juta orang di seluruh dunia menggunakan mata uang kripto, menciptakan permintaan yang terus meningkat untuk dompet kripto dan solusi keuangan yang aman.',
  tokenStructure: 'STRUKTUR TOKEN',
  onlyEmtVill: 'HANYA 210.000.000 EMT AKAN DILUNCURKAN SELAMA PRESALE!',
  remainingTokens: 'Token Terjual',
  totalRaised: 'Total token terjual',
  other: 'Lainnya',
  is: 'adalah',
  connectWallet: 'Hubungkan dompet',
  operationInProgress: 'Transaksi sedang berlangsung',
  pleaseWait: 'Harap tunggu',
  buying: 'Membeli',
  for: 'untuk',
  confirmThisTransaction: 'Konfirmasi transaksi ini di dompet Anda',
  changeMetamaskWallet: 'Ganti Dompet Metamask',
  connectedWith: 'Terhubung dengan',
  copyAddress: 'Salin Alamat',
  viewOnExplorer: 'Lihat di Penjelajah',
  checkAddressText:
    'Anda dapat memasukkan alamat dompet yang Anda gunakan untuk membeli token kami untuk melihat jumlah dan statusnya.',
  frozenFor: 'Dibekukan selama ',
  month: 'bulan',
  months: 'bulan',
  scheduleOfThe: 'Jadwal urutan pencairan dana',
  back: 'KEMBALI',
  available: 'Tersedia',
  buy: 'Beli',
  enterTheWallet: 'Masukkan alamat tempat Anda ingin menerima token DOLLUM.',
  addressMustBe:
    'Gunakan hanya jaringan BSC untuk menerima token Anda dengan aman',
  youAreAt: 'Anda berada di langkah',
  of: 'dari',
  notUseExchangeWallets:
    'Gunakan hanya dompet DeFi (misalnya MetaMask, Trust Wallet, Coinbase Wallet). Jangan gunakan dompet exchange',
  continue: 'Lanjutkan',
  youAreOnLast: 'Anda berada di langkah terakhir',
  youMustTransfer: 'Anda harus mentransfer dana sebesar',
  address: 'Alamat',
  thisOperationTakes:
    'Transaksi membutuhkan waktu hingga 3 jam untuk diselesaikan',
  update: 'Perbarui',
  copyTransactionHash: 'Salin hash transaksi',
  copy: 'Salin',
  depositTheSpecified: 'Setorkan dana yang ditentukan ke dompet ini',
  balance: 'Saldo',
  receive: 'Terima',
  theOperationSuccessful: 'Transaksi berhasil',
  yourFundsWill: 'Dana Anda akan ditransfer ke dompet Anda',
  afterTheCompletion:
    'Setelah selesainya semua putaran presale, proses pembukaan kunci token DOL akan dimulai',
  theAmountOf: 'Jumlah dari',
  setOneText1: 'Nilai pasar dompet kripto $1,5 miliar pada tahun 2023',
  setOneText2: '40% pendapatan pasar didorong oleh perdagangan kripto',
  setOneText3: '50% pertumbuhan pengiriman uang kripto dalam dekade berikutnya',
  setTwoText1: '70% pengguna lebih menyukai staking dan integrasi DeFi',
  setTwoText2: '$175 juta potensi pendapatan dari penjualan token',
  setTwoText3: '10% dari total pasokan dialokasikan untuk inisiatif pemasaran',
  metric: 'Metrik',
  currentMarketState: 'Keadaan Pasar Saat Ini',
  forecastedGrowth: 'Pertumbuhan yang Diproyeksikan',
  userSegments: 'Segmen Pengguna',
  opportunitiesForDollum: 'Peluang untuk Dompet DOLLUM',
  marketValue: 'Nilai Pasar',
  retailInvestorsFinancial: 'Investor ritel, lembaga keuangan',
  increasingDemandFor: 'Permintaan yang meningkat untuk dompet kripto',
  numberOfCrypto: 'Jumlah Pengguna Kripto',
  expectedToReach: 'Diharapkan mencapai 500+ juta pada tahun 2030',
  youthEntrepreneursInstitutional: 'Anak muda, pengusaha, klien institusional',
  attractNewUsers: 'Menarik pengguna baru melalui DeFi',
  mobileWalletShare: 'Pangsa Dompet Seluler',
  belongsToAndroid: '45% dari pasar dimiliki oleh Android',
  mobileSolutionsExpected:
    'Solusi seluler diperkirakan tumbuh 10% setiap tahun',
  smartphoneUsers: 'Pengguna ponsel pintar',
  convenienceAndMobile: 'Kenyamanan dan akses seluler',
  defiAndStacking: 'DeFi dan Staking',
  integrationWithDefi: 'Integrasi dengan protokol DeFi',
  exponentialGrowthIn: 'Pertumbuhan eksponensial dalam permintaan layanan DeFi',
  activeCryptoInvestors: 'Investor kripto aktif',
  directAccessTo: 'Akses langsung ke staking dan DEX',
  marketRegions: 'Wilayah Pasar',
  marketLeaders: 'Pemimpin pasar: Amerika Utara, Asia',
  asiaAndLatin: 'Asia dan Amerika Latin – paling menjanjikan',
  entrepreneursAndLow: 'Pengusaha dan pengguna berpenghasilan rendah',
  expansionIntoNew: 'Ekspansi ke pasar baru',
  millionCryptoUsers: 'juta pengguna kripto di seluruh dunia',
  allocationOfFunds: 'ALOKASI DANA',
  seedRound: 'Putaran seed',
  round: 'putaran',
  Round: 'Putaran',
  tokenPrice: 'Harga token',
  privateRound: 'Putaran pribadi',
  presaleRound: 'Putaran presale',
  publicSaleRound: 'Putaran penjualan publik',
  marketingCommunityBuilding: 'Pemasaran, Pembangunan komunitas, Airdrop',
  teamAndFounders: 'Tim dan Pendiri',
  ecosystemDevelopmentFund: 'Dana Pengembangan Ekosistem',
  liquidityFund: 'Dana Likuiditas',
  stakingRewards: 'Hadiah staking',
  reserveFund: 'Dana Cadangan',
  usersChooseStaking: '70% pengguna memilih staking di DOLLUM',
  theMajorityOf:
    'Mayoritas pengguna Dompet DOLLUM secara aktif terlibat dalam staking untuk mendapatkan penghasilan tetap dan berpartisipasi dalam pertumbuhan ekosistem DeFi, mendapatkan keuntungan dari APY tinggi dan keamanan dompet.',
  preliminaryEstimateBased:
    '**Ini adalah perkiraan awal berdasarkan tren pasar saat ini.',
  roadmapText1: 'Dompet non-custodial',
  roadmapText1Part2: 'Fitur custodial inti',
  roadmapText1Part3: 'Whitepaper',
  roadmapText2: 'Dompet non-custodial',
  roadmapText2Part2: 'Fitur custodial inti ',
  roadmapText2Part3: 'Whitepaper ',
  roadmapText3: 'Anti-pembajakan',
  roadmapText3Part2: 'Peluncuran Dompet ',
  roadmapText3Part3: 'Fitur alamat cadangan',
  roadmapText3Part4: 'Transfer darurat ',
  roadmapText3Part5: 'Manajer portofolio',
  roadmapText4: 'Tokenomics dan Penjualan Token',
  roadmapText4Part2: 'Pengoptimal komisi',
  roadmapText4Part3: 'Pesan di dalam transaksi',
  roadmapText5: 'NFT di dalam dompet',
  roadmapText5Part2: 'Beli kripto dengan fiat',
  roadmapText5Part3: 'Swap menggunakan fitur dompet non-custodial',
  roadmapText6: 'Beta Publik',
  roadmapText6Part2:
    'Kemitraan strategis dengan lembaga perbankan global untuk mengintegrasikan token DOL sebagai aset standar dolar.',
  roadmapText6Part3: 'Kartu bank',
  roadmapText6Part4: 'Listing di Bursa Kripto',
  roadmapText6Part5: 'Beta bursa kripto Dollum',
  roadmapText7: 'Peluncuran Dompet',
  roadmapText7Part2:
    'Adopsi token DOL sebagai instrumen digital untuk inisiatif yang dipimpin pemerintah.',
  roadmapText7Part3: 'Blockchain Dollum',
  roadmapText7Part4: 'Beta NFT Marketplace',
  roadmapText8: 'Peluncuran bursa kripto',
  roadmapText8Part2: 'Peluncuran NFT Marketplace',
  tokenRoadmap: 'Peta jalan token',
  roadmap: 'Peta Jalan',
  competitorComparison: 'Perbandingan dengan kompetitor',
  featureAttribute: 'Fitur/Atribut',
  typeOfWallet: 'Jenis Dompet',
  custodialNonCustodial: 'Custodial & Non-custodial',
  nonCustodial: 'Non-custodial',
  cryptocurrenciesSupported: 'Mata Uang Kripto yang Didukung',
  bitcoinEthereumTron: 'Bitcoin, Ethereum, Tron, Polygon, dan lainnya',
  thousandCoins: '1.000+ koin',
  ethereumTokens: 'Ethereum, token ERC-20',
  assets130: '130+ aset',
  assets500: '500+ aset',
  supportedPlatforms: 'Platform yang Didukung',
  defiIntegration: 'Integrasi DeFi',
  yes: 'Ya',
  stakingSupport: 'Dukungan Staking',
  no: 'Tidak',
  tokenSwapping: 'Pertukaran Token',
  yesNativeExternal: 'Ya (native & eksternal)',
  securityFeatures: 'Fitur Keamanan',
  biometricPassword: 'Biometrik, Kata Sandi',
  passwordPrivateKey: 'Kata Sandi, Kunci Pribadi',
  biometric2Fa: 'Biometrik, 2FA',
  kycCompliance: 'Kepatuhan KYC/AML',
  yesForCustodial: 'Ya (untuk custodial)',
  backupRecovery: 'Cadangan & Pemulihan',
  yesSeedPhrases: 'Ya (frasa seed, 2FA)',
  yesSeedPhrase: 'Ya (frasa seed)',
  supportedBlockchains: 'Blockchain yang Didukung',
  multiBlockChainCustom: 'Multi-blockchain (dapat disesuaikan)',
  multiBlockchain: 'Multi-blockchain',
  userInterface: 'Antarmuka Pengguna',
  intuitiveCustomizable: 'Intuitif, dapat disesuaikan (tema gelap/terang)',
  simpleCleanInterface: 'Antarmuka sederhana, bersih',
  simpleDeveloperFocused: 'Sederhana, berfokus pada pengembang',
  cleanAndUser: 'Bersih dan ramah pengguna',
  visualAppealing: 'Menarik secara visual, dapat disesuaikan',
  cleanSimple: 'Bersih, sederhana',
  crossChainSwapping: 'Pertukaran Lintas Rantai',
  fees: 'Biaya',
  adjustableOptimizedUsing:
    'Dapat disesuaikan, dioptimalkan menggunakan Pengoptimal Komisi',
  adjustable: 'Dapat disesuaikan',
  fixedForCustodial:
    'Tetap untuk custodial; dapat disesuaikan untuk non-custodial',
  backupAddressFeature: 'Fitur Alamat Cadangan',
  yesNonCustodial: 'Ya (non-custodial)',
  pushNotifications: 'Notifikasi Push',
  hardwareWalletSupport: 'Dukungan Dompet Perangkat Keras',
  yesViaTrezor: 'Ya (melalui Trezor)',
  yesLedgerTrezor: 'Ya (Ledger/Trezor)',
  yesTrezor: 'Ya (Trezor)',
  yesLedger: 'Ya (Ledger)',
  nftSupport: 'Dukungan NFT',
  feeOptimization: 'Optimasi Biaya',
  yesCommissionOptimizer: 'Ya (Pengoptimal Komisi)',
  twoFactorAuth: 'Autentikasi Dua Faktor (2FA)',
  fiatConversion: 'Konversi Fiat',
  yesCustodialOnly: 'Ya (hanya custodial)',
  mobileSpecificFeatures: 'Fitur Khusus Seluler',
  storiesEmergencyStop: 'Stories, Berhenti Darurat, Anti-Pembajakan',
  none: 'Tidak ada',
  adminPanel: 'Panel Admin',
  yesCustodialService: 'Ya (untuk layanan custodial)',
  nativeDexAddress: 'Akses DEX Asli',
  decentralizedAppBrowser: 'Peramban Aplikasi Terdesentralisasi',
  biometricLogin: 'Login Biometrik',
  reputationSystem: 'Sistem Reputasi',
  yesInternalWallet: 'Ya (penilaian dompet internal)',
  additionalSecurityTools: 'Alat Keamanan Tambahan',
  emergencyStopAnti: 'Berhenti Darurat, Anti-Pembajakan',
  languagesSupport: 'Bahasa yang Didukung',
  multiLanguageSupport: 'Dukungan multi-bahasa',
  english: 'Bahasa Inggris',
  customerSupport: 'Dukungan Pelanggan',
  yesBuildIt: 'Ya (opsi dukungan bawaan)',
  yesHelpCenter: 'Ya (pusat bantuan)',
  yes24Support: 'Ya (dukungan 24/7)',
  yesInApp: 'Ya (dukungan dalam aplikasi)',
  frequentlyAskedQuestions: 'PERTANYAAN YANG SERING DIAJUKAN',
  howFindFrequently:
    'Di sini Anda dapat menemukan semua pertanyaan yang sering diajukan tentang produk kami',
  faqTitle1: 'Bagaimana cara membuat dompet di Dompet DOLLUM?',
  faqTitle2: 'Berapa biaya yang dikenakan Dompet DOLLUM?',
  faqTitle3: 'Apakah dompet ini mendukung integrasi DeFi?',
  faqTitle4: 'Bagaimana cara menggunakan fitur Berhenti Darurat?',
  faqTitle5: 'Bisakah Dompet DOLLUM digunakan untuk menyimpan NFT?',
  faqTitle6:
    'Bagaimana cara memulihkan akses dompet jika perangkat saya hilang?',
  faqText1:
    'Untuk membuat dompet, cukup unduh aplikasinya, selesaikan pendaftaran, pilih jenis dompet (custodial/non-custodial), dan simpan frasa seed Anda dengan aman untuk mengakses.',
  faqText2:
    'Dompet DOLLUM secara otomatis mengoptimalkan biaya transaksi dengan memilih tarif terendah yang tersedia, meminimalkan biaya pengguna selama operasi.',
  faqText3:
    'Ya, Dompet DOLLUM sepenuhnya mendukung protokol DeFi, memungkinkan pengguna untuk berpartisipasi dalam staking, farming, dan pertukaran token melalui DEX terintegrasi.',
  faqText4:
    'Fitur Berhenti Darurat secara instan mengubah aset menjadi stablecoin atau mengunci dompet jika keamanan terancam. Fitur ini dapat diaktifkan melalui pengaturan dompet.',
  faqText5:
    'Ya, Dompet DOLLUM mendukung penyimpanan, peninjauan, dan perdagangan NFT, memungkinkan pengguna untuk mengelola koleksi digital mereka dengan aman langsung di dalam dompet.',
  faqText6:
    'Anda dapat memulihkan akses ke dompet Anda menggunakan frasa seed yang diberikan saat pembuatan dompet. Pastikan untuk menyimpan frasa seed di lokasi yang aman.',
  footerReservedText:
    'Situs web ini dioperasikan oleh SecureLabs LTd yang didirikan di bawah hukum Seychelles, alamat terdaftar: Suite 1, Second Floor, Sound & Vision House, Rue Pierre De Possession, Victoria, Mahe, Seychelles. Semua hak dilindungi undang-undang',
  termsOfUse: 'Ketentuan penggunaan',
  privacyPolicy: 'Kebijakan Privasi',
  cookiePreferences: 'Preferensi Cookie',
  agreeToTransaction:
    'Saya menyetujui transaksi, serta klausul yang dijelaskan dalam ',
  and: 'dan',
  termsAndConditions: 'Syarat dan Ketentuan',
  alsoYouCan: 'Anda juga dapat memverifikasi konfirmasi alokasi Anda di ',
  usingTheTransaction:
    'menggunakan hash transaksi. Anda selalu dapat melihat jadwal pembukaan kunci token DOL Anda secara rinci di situs ini dengan menyediakan alamat penerima.',
  followUsOn: 'Ikuti kami di media sosial',
  lockedFor: 'Terkunci selama',
  selectNetwork: 'Pilih jaringan',
  dolTokenWill: 'Token DOL akan diluncurkan di Jaringan Binance Smart Chain',
  copyTxHash: 'Salin hash tx',
  theOperationExpired: 'Operasi telah kedaluwarsa',
  waitingTimeHas: 'Waktu tunggu telah habis, coba lagi',
  ifTheProblem: 'Jika masalah terulang, silakan ',
  sendUsEmail: 'kirimkan email kepada kami',
  contactSupport: 'hubungi dukungan',
  tryAgain: 'Coba lagi',
  theOperationFailed: 'Operasi gagal',
  error: 'Kesalahan',
  tokenUnlockingSchedule: 'Jadwal Pembukaan Kunci Token:',
  promoCodeUsed: 'Kode promo berhasil digunakan',
  congratulations: 'Selamat',
  youCanActivate: 'Anda dapat mengaktifkan kode promo untuk ',
  activateYourPromocode: 'Aktifkan kode promo Anda',
  getting: 'Mendapatkan',
  totalRaisedInUsd: 'Total terkumpul',
  nextStage: 'Tahap selanjutnya',
  pay: 'Bayar',
  info: 'Info',
  dollumApp: 'Dollum App',
  trustApp: 'Trust App',
  metamask: 'Metamask',
  coinbaseApp: 'Coinbase App',
  exodusApp: 'Exodus App',
  cryptoComDefi: 'Crypto.com DeFi',
  bonusRowsState1: '$1,5 miliar pada tahun 2023',
  bonusRowsGrowth1: '$1,5 miliar pada tahun 2023',
  bonusRowsState2: '320+ juta pengguna kripto',
  multiformatSupport: 'Bitcoin, Ethereum, ERC-20',
  iosAndroidDesktopLightVersion: 'iOS, Android, Desktop (Versi Ringan)',
  iosAndroid: 'iOS, Android',
  iosAndroidChrome: 'iOS, Android, Chrome',
  iosAndroidBrowser: 'iOS, Android, Peramban',
  iosAndroidDesktop: 'iOS, Android, Desktop',
  biometricPin2Fa:
    'Biometrik, PIN, 2FA, “SSL pinning”, enkripsi AES-256, “Berhenti Darurat”, “Anti-Pembajakan”',
  ethereum: 'Ethereum',

  poweredBy: 'Didukung oleh',
  live: 'Langsung',
  auditAndKycVerified: 'Audit & KYC Terverifikasi',
  teamKycVerification: 'Verifikasi KYC Tim',
  smartContractAudit: 'Audit Smart Contract',
  securityComesFirst: 'Keamanan adalah yang utama.',
  ourSmartContractHasBeenFullyAudited:
    'Smart contract kami telah diaudit sepenuhnya',
  bySolidProof: 'oleh SolidProof,',
  oneOfTheLeadingBlockchainAuditFirms:
    'salah satu perusahaan audit blockchain terkemuka.',
  additionally: 'Selain itu,',
  dollumTeamCompletedKYC: 'tim Dollum berhasil menyelesaikan verifikasi KYC',
  ensuringTransparencyAndAccountability:
    ', memastikan transparansi dan akuntabilitas untuk komunitas kami.',
  servicesAndCertificates: 'Layanan & Sertifikat',
  kyc: 'KYC',
  securityScore: 'Skor Keamanan',
  poor: 'Buruk',
  excellent: 'Sangat Baik',
  writesMediaAboutUs: 'Media tentang kami',

  stageTwoAlmostSold: 'Tahap 2 hampir habis terjual — Harga berikutnya: $0.20',
  buyBeforeThePriceIncreases: 'Beli sekarang seharga $0.15 sebelum harga naik!',

  useOnlyDefiWallet:
    'Gunakan hanya dompet DeFi seperti MetaMask, Trust Wallet, atau Coinbase Wallet.',
  makeSureYourWalletIsConnectedToTheBsc:
    'Pastikan dompet Anda terhubung ke jaringan BSC (Binance Smart Chain).',
  copyYourBscWalletAddress:
    'Salin alamat dompet BSC Anda (dimulai dengan 0x) dan tempelkan ke kolom.',
  doNotUseExchangeWallets:
    'Jangan gunakan dompet exchange (seperti Binance, KuCoin, atau OKX).',

  needHelp: 'Butuh bantuan?',

  stage3IsSellingFast:
    'Tahap Presale Terakhir — Kesempatan Terakhir Sebelum Listing',
  nextStagePriceIncreases:
    'Amankan token Anda sekarang sebelum harga listing awal yang direncanakan sebesar $1.00',
  finalPresaleStage: 'Tahap Presale Terakhir',

  weAreLive: 'Kami sudah live!',
  weWillLiveSoon: 'Kami akan segera live',
  startManagingYourCryptoSecurely: 'Mulai kelola kripto Anda dengan aman',

  launchpadIntroduction: 'Pengenalan Launchpad',
  continuedPlatformDevelopment:
    'Pengembangan platform berkelanjutan dan perluasan ekosistem',
  expansionIntoIntegratedFinancialServices:
    'Ekspansi ke layanan keuangan terintegrasi, termasuk kemampuan pembayaran dan peminjaman',
  ecosystemScaling: 'Skalabilitas ekosistem dan perluasan fitur',
  platformOptimizationAndInfrastructure:
    'Optimalisasi platform dan penguatan infrastruktur',
  platformForBroaderMarketIntegration:
    'Persiapan untuk integrasi pasar yang lebih luas',
  structuredDigitalFinanceEcosystem:
    'EKOSISTEM KEUANGAN DIGITAL YANG TERSTRUKTUR',
  dollumCombinesSecureWallet:
    'Dollum menggabungkan infrastruktur dompet yang aman, staking, dan alat keuangan terintegrasi dalam satu platform terpadu — dengan perluasan ke kemampuan pembayaran dan peminjaman.',
  finalStageLimitedAllocationRemaining:
    'Tahap akhir — alokasi terbatas tersisa',
  nowAvailable: 'Sekarang tersedia',
  digitalAssetManagement:
    'Manajemen aset digital dengan kemampuan pembayaran terintegrasi',
};
